import { createUseStyles } from 'react-jss';

const styles = {
  layoutWrapper: {
    display: 'flex',
    // it's the point when right sidebar is visible
    '@media(min-width: 1651px)': {
      justifyContent: 'space-between',
    },
  },
  content: {
    minHeight: '100vh',
    maxWidth: '119rem',
    margin: '0 auto',
    '@media(max-width: 1024px)': {
      paddingTop: '5rem',
      width: '100%',
    },
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
